import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import MainLayout from "../components/layout/MainLayout";

import Dashboard from "../pages/Dashboard/Dashboard";
import EmailSetting from "../pages/Settings/EmailSetting";
import Tickets from "../pages/Tickets/Ticket";
import TicketField from "../pages/Settings/TicketField";
import Category from "../pages/Settings/Category";
import Type from "../pages/Settings/Type";
import Status from "../pages/Settings/Status";
import { setAuthData, getToken } from "../services/authStore";

function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (token) {
      try {
        const decodedUser = jwtDecode(token);
        setAuthData(token, decodedUser);
        navigate("/", { replace: true });
      } catch (error) {
        console.error("Invalid token");
      }
    }

    setLoading(false);
  }, [location, navigate]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!getToken()) {
    return <div>Unauthorized</div>;
  }

  return (
    <>
      {/* ✅ Toaster added once globally */}
      <Toaster position="top-right" reverseOrder={false} />

      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="tickets" element={<Tickets />} />
          <Route path="emailsetting" element={<EmailSetting />} />
          <Route path="ticketfield" element={<TicketField />} />
          <Route path="category" element={<Category />} />
          <Route path="type" element={<Type />} />
          <Route path="status" element={<Status />} />
        </Route>
      </Routes>
    </>
  );
}
export default function AppRoutes() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
